import {useDayStore} from "@/store/day";
import {useMberStore} from "@/store/mber";
import {useLoadingStore} from "@/store/loading";
import {useRouter} from "vue-router";

import {useCmmn} from "@/utils/cmmn";
import {useValid} from "@/utils/valid";
import {useAlert} from "@/utils/alert";
import {useConfirm} from "@/utils/confirm";
import {useFile} from "@/utils/file";
import {useAxios} from "@/utils/axios";
import {usePopup} from "@/utils/popup";
import {useCd} from "@/utils/cd";
import {useMenu} from "@/utils/menu";
import {useCmmnPopup} from "@/utils/cmmn-popup";
import {useFirebase} from "@/utils/firebase";

const getStore = () => ({
    $day: useDayStore(),
    $mber: useMberStore(),
    $loading: useLoadingStore()
});

const getUtils = () => ({
    $router: useRouter(),
    $axios: useAxios(),
    $file: useFile(),
    $alert: useAlert(),
    $confirm: useConfirm(),
    $valid: useValid(),
    $cmmn: useCmmn(),
    $popup: usePopup(),
    $cd: useCd(),
    $menu: useMenu(),
    $cmmnPopup: useCmmnPopup(),
    $firebase: useFirebase(),
});


export { getStore, getUtils };
